import React from 'react';
import { ApiProvider, getReducers } from '@leverege/api-redux';

/**
 * Creates an initializer and provider creator for Api
 */
export default {
  id: 'openApi.ApiInit',
  sort: -100,
  createReducers: molten => {
    return getReducers();
  },
  /**
   * Creates an ApiProvider and attaches the children
   */
  createProvider: (molten, ...children) => {
    // eslint-disable-next-line react/destructuring-assignment
    return /*#__PURE__*/React.createElement(ApiProvider, {
      api: molten.get('api')
    }, ...children);
  }
};